// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/main.css
// module id = MyJP
// module chunks = 1